import React from 'react';
import { useParams } from 'react-router-dom';
import { useBlog } from '../../context/BlogContext';
import BlogCard from './BlogCard';

export default function BlogRelatedPostsBlock({ data }) {
  const { publishedPosts } = useBlog();
  const { slug: currentSlug } = useParams();
  const { title = 'Continúa explorando', description, postSlugs = [], layout = 2 } = data || {};

  // Slugs elegidos en el editor, sin duplicados y sin el post actual (evita que
  // "Continúa explorando" muestre el mismo artículo repetido).
  const uniqueSlugs = [...new Set(postSlugs.filter(Boolean))].filter(s => s !== currentSlug);

  let relatedPosts = [];
  if (uniqueSlugs.length > 0) {
    relatedPosts = uniqueSlugs
      .map(slug => publishedPosts.find(p => p.slug === slug))
      .filter(Boolean);
  } else {
    // Fallback: otros posts publicados (excluyendo el actual).
    relatedPosts = publishedPosts.filter(p => p.slug !== currentSlug).slice(0, layout);
  }

  if (!relatedPosts.length) return null;

  return (
    <div className="blog-related-posts">
      {title && <h3 className="blog-related-posts__title">{title}</h3>}
      {description && <p className="blog-related-posts__description">{description}</p>}
      <div className="blog-related-posts__grid" style={{ gridTemplateColumns: `repeat(${layout}, 1fr)` }}>
        {relatedPosts.map(post => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
}
